var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"cursive-font my-2 mx-2 black--text"},[_vm._v("Manage your account details")]),_c('div',{staticClass:"d-flex flex-row flex-wrap"},[_c('user-info'),_c('associate-info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }